<template>
  <div>
    <el-upload
    class="upload-demo"
    drag
    :action="`${uploadUrl}`"
    name="docs"
    :on-preview="handlePreview"
    :on-success="handleSuccess"
    :on-error="handleError"
    :on-remove="handleRemove"
    :before-remove="beforeRemove"
    :file-list="fotos"
    multiple>
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">Arrastra o <em>pulsa</em></div>
    <div class="el-upload__tip" slot="tip">{{label}}</div>
    </el-upload>
  </div>
</template>
<script>
  export default {
    props: ['fotos', 'label', 'baseUrl', 'deleteUrl'],
    data() {
      return {
        fileList: [],
        uploadUrl: null
      };
    },
    created() {
      //do something after creating vue instance
      this.uploadUrl = this.baseUrl + '&_token=' + Larapp.csrfToken;
      this.fileList = this.photos;
    },
    methods: {
      handleRemove(file, fileList) {
        let deleteUrl = this.deleteUrl +'/'+file.id;
        window.axios
          .get(deleteUrl)
          .then(res => {
            if (res.data && res.data.success) {
              this.$notify({title: file.name, message: res.data.message, verticalAlign: 'top', type: 'success'});
            } else {
              this.$notify({title: 'Error',
                message:
                  'Algo no marcha bien, contacta con tu administrador WEB.',
                verticalAlign: 'top', type: 'warning'
              });
            }
            // record.is_active = res === 1
          })
          .catch(error => {
            window.Larapp.processErrors(error);
            this.fotos = fileList;
          });
      },
      handlePreview(file) {
        window.open(file.url);
      },
      handleSuccess(response, file, fileList) {
        this.fotos = response.fileList;
        this.$notify({title: 'Archivo subido ' + file.name, verticalAlign: 'top', type: 'success'});
      },
      handleError(err, file, fileList) {
        this.$notify({title: 'Error', verticalAlign: 'top', type: 'warning',
          message: 'No se pudo terminar la carga del archivo',
        });
      },
      handleExceed(files, fileList) {
        this.$message.warning(`The limit is 3, you selected ${files.length} files this time, add up to ${files.length + fileList.length} totally`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`¿Eliminar ${ file.name }？\nNo se puede deshacer.`);
      }
    }
  }
</script>
<style>
.el-upload{
  width: 100% !important;
}
.el-upload-dragger {
  width: 100% !important;
  height: 130px !important;
}
.el-upload__tip{
  font-size: 1.5rem;
  font-weight: bold;
  text-transform: uppercase;
  color:rgb(77, 83, 96);
  text-align: center;
  margin-top: 18px;
  margin-bottom: 18px;
}
.el-icon-upload{
  margin-top: 20px !important;
}
</style>
